// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610021604/js/" + chunkId + "." + {"44":"1598f849","225":"b7283c5a","481":"55e2ad7a","486":"5fca8f49","770":"91a61e37"}[chunkId] + ".0.5005733980969312.chunk.js";
};